/**
 * Change-log entry — one recorded edit to a partner's account or a tier.
 * The metrics layer reads these to count *manual entitlement drift* (cap
 * changes made directly on an account, outside a standard tier change).
 * See `./partner.ts` for the generated-schema note.
 */
export interface ChangeLogEntry {
  /** Display timestamp as recorded, e.g. "08/10 14:32". */
  time: string;
  /** Partner name (or a tier label like "Growth (tier)"). */
  partner: string;
  /** Which field changed, e.g. "Saved search cap". */
  field: string;
  from: string;
  to: string;
  /** Who made the change. */
  by: string;
}

/**
 * Fields whose change counts as manual entitlement drift — a cap adjusted
 * directly on an account rather than by moving the partner between tiers.
 */
export const DRIFT_FIELDS: readonly string[] = ["Saved search cap", "Ad hoc result cap"];
